import { CustomInput, CustomTextArea } from "../../../Common/CustomInputs";
import CustomTagInput from "../../../Common/CustomTagInput";
import { Gapper } from "../../../ui/Gapper";
import { SectionHeader, FormRow } from "../../shared/practitionerForm.styles";
import { AddressFieldsGrid } from "../ResourcesModal.styles";
import { colors } from "../../../../theme/theme";
import { Box } from "@mui/material";
import {
  TAG_VALIDATION_MSG,
  PLACEHOLDER_LANGUAGES,
  LABEL_LANGUAGES,
  PLACEHOLDER_PHONE,
  LABEL_PHONE,
  PLACEHOLDER_DESCRIPTION,
  LABEL_DESCRIPTION,
} from "../../shared/practitionerForm.constants";
import {
  ADDRESS_FIELDS,
  LABEL_COUNTRY,
  PLACEHOLDER_COUNTRY,
} from "../ResourcesModal.constants";
import { CustomDropdown } from "../../../Common/CustomDropdown";

const ContactInfoSection = ({ formData, updateField, countries }) => {
  return (
    <Gapper gap={15}>
      <SectionHeader>Contact Info</SectionHeader>
      <FormRow>
        <CustomTagInput
          hashTags={formData.languages}
          setHashTags={(value) => updateField("languages", value)}
          color={colors.primary}
          placeholder={PLACEHOLDER_LANGUAGES}
          label={LABEL_LANGUAGES}
          validation
          validationMsg={TAG_VALIDATION_MSG}
        />
        <CustomInput
          value={formData.phone}
          setValue={(value) => updateField("phone", value)}
          placeholder={PLACEHOLDER_PHONE}
          label={LABEL_PHONE}
          type="number"
          smallBr
          bR="14px"
          width="100%"
          noIcon
          color={colors.primary}
        />
      </FormRow>
      <SectionHeader>Address</SectionHeader>
      <AddressFieldsGrid>
        {ADDRESS_FIELDS.map(({ name, label, placeholder }) => (
          <CustomInput
            key={name}
            value={formData[name]}
            setValue={(value) => updateField(name, value)}
            placeholder={placeholder}
            label={label}
            smallBr
            bR="14px"
            width="100%"
            noIcon
            color={colors.primary}
          />
        ))}
        <Box
          sx={{ display: "flex", flexDirection: "column", minWidth: "180px" }}
        >
          {/* <FieldLabel>{LABEL_COUNTRY}</FieldLabel> */}
          <CustomDropdown
            label={LABEL_COUNTRY}
            value={formData.country || ""}
            setValue={(value) => updateField("country", value)}
            placeholder={PLACEHOLDER_COUNTRY}
            data={countries.map((country) => ({
              value: country,
              label: country,
            }))}
            noIcon
            color={colors.primary}
            width="100%"
          />
        </Box>
      </AddressFieldsGrid>
      <CustomTextArea
        placeholder={PLACEHOLDER_DESCRIPTION}
        label={LABEL_DESCRIPTION}
        value={formData.desc}
        setValue={(value) => updateField("desc", value)}
        width="100%"
        noIcon
      />
    </Gapper>
  );
};

export default ContactInfoSection;
